import { render, staticRenderFns } from "./CustomerPayMethodList.vue?vue&type=template&id=c5d89b08&scoped=true&"
import script from "./CustomerPayMethodList.vue?vue&type=script&lang=js&"
export * from "./CustomerPayMethodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d89b08",
  null
  
)

export default component.exports